import { render, staticRenderFns } from "./logisticsCard.vue?vue&type=template&id=fe48403c&scoped=true&"
import script from "./logisticsCard.vue?vue&type=script&lang=js&"
export * from "./logisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCard.vue?vue&type=style&index=0&id=fe48403c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe48403c",
  null
  
)

export default component.exports